module.exports = __webpack_public_path__ + "static/media/toronto.677d3623.jpg";